import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { fetchTvEpisodes } from '../actions';

class TvEpisodeList extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    episodes: PropTypes.object,
    showId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  };

  componentDidMount() {
    this.props.dispatch(fetchTvEpisodes(this.props.showId));
  }

  render() {
    const { episodes } = this.props;

    if (!episodes.get('loaded')) {
      return null;
    }

    return (
      <div className="admin-paper__content" key="show-episodes">
        <h4>Episodes</h4>
        <div className="card__wrapper">
          {episodes.get('data').size ? (
            episodes.get('data').map(episode => (
              <Link
                to={`/tv/shows/${episode.get('show_id')}/episodes/${episode.get('id')}`}
                className="episode__card"
                key={`tv-episode-${episode.get('id')}`}
              >
                {episode.get('image_id') ? (
                  <div
                    className="episode__card-image"
                    style={{ backgroundImage: `url(${episode.getIn(['image', 'location'])})` }}
                  />
                ) : (
                  <div className="episode__card-image image__placeholder">No Image</div>
                )}
                <h4>"{episode.get('name')}"</h4>
                <p>{episode.get('description')}</p>
                <div className="button">Edit Episode</div>
              </Link>
            ))
          ) : (
            <div className="admin-paper__no-content">There are currently no episodes</div>
          )}
        </div>
      </div>
    );
  }
}

export default connect(state => {
  return {
    episodes: state.tv.episodes,
  };
})(TvEpisodeList);



// WEBPACK FOOTER //
// ./src/tv/episodes/TvEpisodeList.js